import React, { useState, useEffect } from 'react';

const PostTable = ({ posts, onDelete, onEdit }) => {
  const [sortedPosts, setSortedPosts] = useState([]);
  const [sortAsc, setSortAsc] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({ id: '', name: '', description: '', link: '', date: '' });

  useEffect(() => {
    const sorted = [...posts].sort((a, b) =>
      sortAsc ? new Date(a.date) - new Date(b.date) : new Date(b.date) - new Date(a.date)
    );
    setSortedPosts(sorted);
  }, [posts, sortAsc]);

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowDialog(true);
  };

  const confirmDelete = () => {
    onDelete(selectedId);
    setShowDialog(false);
  };

  const handleEditClick = (post) => {
    setFormData({ ...post, link: post.link || '' });
    setEditMode(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    await onEdit({ ...formData, link: formData.link.trim() || null });
    setEditMode(false);
  };

  if (editMode) {
    return (
      <div className="mt-4">
        <h4>Editar Anuncio</h4>
        <form onSubmit={handleEditSubmit}>
          <div className="mb-3">
            <label className="form-label">Título</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Descripción</label>
            <input
              type="text"
              className="form-control"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Link <span className="text-muted">(opcional)</span></label>
            <input
              type="text"
              className="form-control"
              name="link"
              value={formData.link}
              onChange={handleInputChange}
              placeholder="https://..."
            />
          </div>
          <button
            type="submit"
            className="btn"
            style={{ backgroundColor: '#C73B33', borderColor: '#FF5733', color: '#FFF' }}>
            Guardar Cambios
          </button>
          <button
            type="button"
            className="btn btn-secondary ms-2"
            onClick={() => setEditMode(false)}>
            Cancelar
          </button>
        </form>
      </div>
    );
  }

  return (
    <>
      <table className="table table-striped table-bordered table-hover mt-3">
        <thead>
          <tr>
            <th>Título</th>
            <th>Descripción</th>
            <th>Link</th>
            <th
              onClick={() => setSortAsc(!sortAsc)}
              style={{ cursor: 'pointer', userSelect: 'none' }}>
              Fecha {sortAsc ? '↑' : '↓'}
            </th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {sortedPosts.map((post) => (
            <tr key={post.id}>
              <td>{post.name}</td>
              <td>{post.description}</td>
              <td>
                {post.link
                  ? <a href={post.link} target="_blank" rel="noreferrer">{post.link}</a>
                  : <span className="text-muted">—</span>}
              </td>
              <td>{post.date}</td>
              <td>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => handleEditClick(post)} className="btn btn-warning btn-sm">
                    Editar
                  </button>
                  <button onClick={() => handleDeleteClick(post.id)} className="btn btn-danger btn-sm">
                    Eliminar
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showDialog && (
        <div style={modalStyles}>
          <div style={modalContentStyles}>
            <h4>¿Estás seguro?</h4>
            <p>Una vez borrado no se puede recuperar</p>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
              <button onClick={confirmDelete} className="btn btn-danger">OK</button>
              <button onClick={() => setShowDialog(false)} className="btn btn-secondary">Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const modalStyles = {
  position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
  backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
  justifyContent: 'center', alignItems: 'center', zIndex: 1000,
};

const modalContentStyles = {
  backgroundColor: 'white', padding: '50px', borderRadius: '5px', textAlign: 'center',
};

export default PostTable;
